import * as React from 'react';
import { LinkButton, Responsive, UIText2 } from '@cian/ui-kit';
import { PromoOfferControls } from '../../components/PromoDetailsModal/components/PromoOfferControls';
import { CallButton } from '../CallButton';
import { MobileCallButton } from '../CallButton/MobileCallButton';

interface IPromoOfferDetailsControlsProps {
  offerUrl: string;
  actionText: string;
  onCallButtonClick(): void;
  onOfferLinkClick(): void;
}

export const PromoOfferDetailsControls = ({
  offerUrl,
  actionText,
  onCallButtonClick,
  onOfferLinkClick,
}: IPromoOfferDetailsControlsProps) => {
  return (
    <>
      <Responsive desktop tablet>
        <PromoOfferControls>
          <LinkButton href={offerUrl} target="_blank" size="M" theme="fill_white_primary" onClick={onOfferLinkClick}>
            Перейти к объявлению
          </LinkButton>
          <CallButton onClick={onCallButtonClick} theme="fill_primary" size="M" placeType="promoPopup" />
        </PromoOfferControls>
      </Responsive>

      <Responsive phone>
        <PromoOfferControls>
          <MobileCallButton placeType="promoPopup" />
          <UIText2 textAlign="center" color="text-secondary-default">
            {actionText}
          </UIText2>
        </PromoOfferControls>
      </Responsive>
    </>
  );
};
